import { Component, Input } from "@angular/core";

@Component({
  selector: "upsell-wait",
  templateUrl: "upsell-wait.html",
  styleUrls: ['upsell-wait.scss'],
})

export class UpsellWaitComponent {

  @Input() iconWait: string = 'https://cdn.drmartypets.com/images/wait.png';
  @Input() iconText: string = 'SPECIAL MESSAGE FROM DR. MARTY';
  @Input() isFull: boolean = false;
  @Input() title: string = '';
  @Input() description: string = '';

  constructor() {}
}
